import {useUpmPlant} from '@hconnect/upm'
import {useForm} from 'react-hook-form'

import {useKilns, useRefraModal} from '@refra/modules/common/providers'
import {useAddMaterialInstallation} from '@refra/modules/refra-planning/hooks/mutations/useAddMaterialIntallation'
import type {AddMaterialInstallationForm} from '@refra/modules/refra-planning/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

interface UseAddInstallationFormParams {
  fromMeter: string
  toMeter: string
  shutdownId: number
}

export const useAddInstallationForm = ({
  fromMeter,
  toMeter,
  shutdownId
}: UseAddInstallationFormParams) => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()
  const {closeModal} = useRefraModal()

  const {mutate: addMaterialInstallation, isPending: isAddingMaterialInstallation} =
    useAddMaterialInstallation()

  const formMethods = useForm<AddMaterialInstallationForm>({
    defaultValues: {
      manufacturerId: undefined,
      refractoryId: undefined,
      fromMeter: fromMeter,
      toMeter: toMeter,
      isMortarRequired: false
    }
  })

  const onSubmit = formMethods.handleSubmit((values: AddMaterialInstallationForm) => {
    if (values.refractoryId !== undefined) {
      addMaterialInstallation(
        {
          material: {
            refractoryId: values.refractoryId,
            fromMeter: Number(values.fromMeter),
            toMeter: Number(values.toMeter),
            isMortarRequired: values.isMortarRequired
          },
          plantUpmId: upmPlant.upmId,
          kilnUpmId: selectedKiln.upmId,
          shutdownId: shutdownId
        },
        {onSuccess: () => onClose()}
      )
    }
  })

  const onClose = () => {
    formMethods.reset()
    closeModal()
  }

  return {formMethods, isFormBeingProcessed: isAddingMaterialInstallation, onSubmit, onClose}
}
